import React from 'react';
import StatusBadge from './StatusBadge';

export default function PaymentAttemptsList({ attempts = [], onRetry }) {
  if (!attempts || attempts.length === 0) {
    return <div className="text-mist/70 text-sm">No payment attempts</div>;
  }

  return (
    <div className="space-y-2">
      {attempts.map(attempt => (
        <div key={attempt.attemptId} className="bg-ink/40 border border-edge/30 rounded-none p-3 flex items-start justify-between">
          <div className="flex-1">
            <div className="flex items-center gap-3 mb-1">
              <div className="text-ice font-medium">{attempt.method.toUpperCase()} • ${attempt.amount.toFixed(2)}</div>
              <StatusBadge status={attempt.status} />
            </div>
            <div className="text-mist/70 text-xs">{new Date(attempt.createdAt).toLocaleString()}</div>
            {attempt.failureReason && <div className="text-red-400 text-sm mt-2">{attempt.failureReason}</div>}
            {attempt.receiptNumber && <div className="text-mist/70 text-sm mt-1">Receipt: {attempt.receiptNumber}</div>}
          </div>

          <div className="ml-4 flex items-start">
            {attempt.status === 'failed' && (
              <button onClick={() => onRetry(attempt)} className="bg-brand text-ink px-3 py-1 rounded-none text-sm">Retry</button>
            )}
          </div>
        </div>
      ))}
    </div>
  );
}
